export default __webpack_public_path__ + "static/media/Globbbb.86645b4a.PNG";